/**
 * Casing helpers for turning field/stage keys into human labels, and back.
 *
 * Deliberately a leaf module with no imports: pure mappers (e.g. the roadmap row builders) need these
 * without dragging in the app's runtime module graph, which is what importing them from `common.tsx`
 * — and therefore `react` and `service/error` — would do.
 */

export const capitalize = (str: string): string => {
  return str.length ? str[0].toUpperCase() + str.slice(1).toLowerCase() : str;
};

export const camelCaseToSentenceCase = (value: string): string => {
  const tokens = value
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/([a-zA-Z])(\d)/g, "$1 $2")
    .replace(/(\d)([a-zA-Z])/g, "$1 $2")
    .split(" ")
    .filter(Boolean);

  return tokens
    .map((token, index) => {
      if (/^[A-Z0-9]+$/.test(token)) {
        return token;
      }

      const normalisedToken = token.toLowerCase();

      return index === 0 ? normalisedToken.charAt(0).toUpperCase() + normalisedToken.slice(1) : normalisedToken;
    })
    .join(" ");
};

export const sentenceOrPascalToCamel = (value: string): string => {
  return value
    .replace(/([A-Z])/g, " $1")
    .toLowerCase()
    .trim()
    .split(/\s+/) // split on any whitespace
    .map((word, index) => (index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
    .join("");
};

export const stringKeyToSentenceCase = (value: string): string =>
  camelCaseToSentenceCase(sentenceOrPascalToCamel(value.replace(/[_-]+/g, " ")));
